import { type FormEvent, useState } from "react"
import { Auth } from "aws-amplify"
import { TextField, Button, FormControl } from "@mui/material";
import "./auth.css";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

interface SignUpFormElements extends HTMLFormControlsCollection {
  email: HTMLInputElement
  password: HTMLInputElement
}

interface SignUpForm extends HTMLFormElement {
  readonly elements: SignUpFormElements
}

interface AuthErr {
  code: string
  message: string
}

export function AuthCreateUser() {
  const [showSuccess, setShowSuccess] = useState(false)
  const [errorMsg, setErrorMsg] = useState("")

  async function handleSubmit(event: FormEvent<SignUpForm>) {
    event.preventDefault()
    const form = event.currentTarget

    try{
      await Auth.signUp({
        username: form.elements.email.value,
        password: form.elements.password.value,
      })
      setErrorMsg("")
      setShowSuccess(true)
    } catch (err: unknown) {
      setShowSuccess(false)
      setErrorMsg((err as AuthErr).message)
    }
  }

  return (
    <div className="auth-create-user">
      <h3>Create Account</h3>
      <form onSubmit={handleSubmit}>
        <FormControl>
          <TextField variant="outlined" id="email" label="Email" name="email" required />
          <TextField variant="outlined" id="password" label="Password" name="password" required />
          <Button variant="contained" type="submit">Submit</Button>
        </FormControl>
      {showSuccess ? (
        <Alert severity="success" onClick={() => {setShowSuccess(false)}}>
          <AlertTitle>Account has been created successfully.</AlertTitle>
        </Alert>
      ) : (<></>)}
      {errorMsg ? (
        <Alert severity="error" onClick={() => {setErrorMsg("")}}>
          <AlertTitle>{errorMsg}</AlertTitle>
        </Alert>
      ) : (<></>)}
      </form>
    </div>

  )
}